import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Hero, { FeaturesSection } from './components/Hero';
import { HighlightsSection, CategoriesSection } from './components/Highlights';
import { DownloadSection } from './components/Download';
import FAQSection from './components/FAQ';
import { SEOContentSection } from './components/SEOContent';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <article>
          <Hero />
          <HighlightsSection />
          <FeaturesSection />
          <CategoriesSection />
          <DownloadSection />
          <FAQSection />
          <SEOContentSection />
        </article>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '91浏览器 - 极速安全的网页浏览体验',
            description: '91浏览器是一款高速、安全、多功能的网页浏览工具，支持多平台使用，内置广告拦截、隐私保护、多标签管理等强大功能。',
            url: 'https://www.91browser.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '91浏览器',
              url: 'https://www.91browser.com',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'https://www.91browser.com/',
                },
              ],
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '91浏览器是免费的吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '是的，91浏览器完全免费使用。我们承诺不会向个人用户收取任何费用，所有核心功能均可免费使用。',
                },
              },
              {
                '@type': 'Question',
                name: '91浏览器如何保护我的隐私？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '91浏览器采用多重隐私保护技术：内置智能反追踪引擎阻止第三方跟踪器收集您的浏览数据；无痕浏览模式下所有浏览记录、Cookie和表单数据自动清除。',
                },
              },
              {
                '@type': 'Question',
                name: '91浏览器支持哪些平台？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '91浏览器全面支持Windows、macOS、Android和iOS四大主流平台，所有平台均支持书签、密码和历史记录的跨设备云同步功能。',
                },
              },
              {
                '@type': 'Question',
                name: '如何导入其他浏览器的书签和密码？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '安装91浏览器后，首次启动时会自动检测您设备上已安装的其他浏览器，并提供一键导入书签、密码和历史记录的选项。',
                },
              },
              {
                '@type': 'Question',
                name: '91浏览器的广告拦截功能如何使用？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '91浏览器默认开启智能广告拦截功能，您无需任何设置即可享受清爽的浏览体验。如需自定义拦截规则，可以在设置中心调整。',
                },
              },
              {
                '@type': 'Question',
                name: '91浏览器会收集我的哪些数据？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '我们坚持最小化数据收集原则。91浏览器仅收集必要的匿名化崩溃诊断数据和匿名的使用统计信息来改进产品，绝不收集您的浏览历史、搜索记录或个人身份信息。',
                },
              },
            ],
          }),
        }}
      />
    </>
  );
}